var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c('div',{staticClass:"modal_wrap"},[_c('div',{staticClass:"backdrop"}),_c('div',{staticClass:"modal_content_wrap"},[_c('div',{staticClass:"modal_content"},[_vm._t("ModalContent",function(){return [_vm._v(" default ")]})],2),_c('button',{staticClass:"modal_btn",on:{"click":_vm.confirmModal}},[_vm._v("확인")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }